import { render, staticRenderFns } from "./tile-icon.vue?vue&type=template&id=8cd41108&"
import script from "./tile-icon.vue?vue&type=script&lang=js&"
export * from "./tile-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/icons/tile-icon.vue
// module id = 1174
// module chunks = 0